module.exports = __webpack_public_path__ + "static/inc2-6249422d8fdc92316abc412244043a83.jpg";